import styled, { keyframes } from 'styled-components';
import { colors } from 'globalStyles';
import ReactModal from 'react-modal';

const shake = keyframes`
  0% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(10px);
  }

  75% {
    transform: translateX(-10px);
  }

  100% {
    transform: translateX(0);
  }
`;

const StyledModal = styled(ReactModal)`
  background-color: ${colors.WHITE};
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  outline: none;
  box-shadow: 0 20px 50px 0 rgba(0, 0, 0, 0.2);
  z-index: 999;

  .modal__overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    min-width: 100%;
    min-height: 100%;
    ${({ shakeOnOpen }) => shakeOnOpen &&`
      animation: ${shake} 150ms ease-in-out;
    `}
    z-index: 99;
  }
`;

export default StyledModal;



// WEBPACK FOOTER //
// ./src/components/Modal/StyledModal.js